<div class="salary-fish-page">
  <div class="salary-actions no-print" *ngIf="!Procssing">
    <button (click)="onBack()" type="button" class="btn btn-warning"><i class="fa fa-mail-reply"></i> بازگشت</button>
    <button (click)="exportPdf()" [disabled]="PdfProcessing" type="button" class="btn btn-danger">
      <i class="fa fa-file-pdf-o"></i> {{PdfProcessing ? 'در حال ایجاد PDF...' : 'خروجی PDF'}}
    </button>
  </div>

  <div #salaryFishPdf id="salaryFishPdf" class="salary-slip" *ngIf="!Procssing && DataList_Salary">
    <header class="salary-slip-header keep-together">
      <div class="period-box">
        <div><span>سال:</span><strong>{{innerYear}}</strong></div>
        <div><span>ماه:</span><strong>{{innerMonth}}</strong></div>
      </div>
      <div class="salary-title"><h1>فیش حقوقی</h1></div>
      <div class="company-logo"><img src="assets/Content/logo2.png" alt="نشان شرکت" /></div>
    </header>

    <section class="employee-info keep-together">
      <h2>اطلاعات پرسنلی</h2>
      <div class="employee-grid">
        <div class="info-item info-item-wide"><span>نام و نام خانوادگی</span><strong>{{DataList_Salary['fullname']}}</strong></div>
        <div class="info-item"><span>کد پرسنلی</span><strong>{{DataList_Salary['code']}}</strong></div>
        <div class="info-item"><span>نام پدر</span><strong>{{DataList_Salary['fathername']}}</strong></div>
        <div class="info-item info-item-wide"><span>پست سازمانی</span><strong>{{DataList_Salary['semat']}}</strong></div>
      </div>
    </section>

    <section class="attendance-summary keep-together">
      <h2>اطلاعات کارکرد و وضعیت ماه</h2>
      <div class="attendance-grid">
        <div class="attendance-item"><span>کارکرد (روز)</span><strong>{{DataList_Salary['day'] | number}}</strong></div>
        <div class="attendance-item"><span>اضافه کار (ساعت)</span><strong>{{DataList_Salary['ezakekarCount'] | number}}</strong></div>
        <div class="attendance-item"><span>ماموریت داخلی</span><strong>{{DataList_Salary['missionCount'] | number}}</strong></div>
        <div class="attendance-item"><span>سابقه کار (سال)</span><strong>{{DataList_Salary['year'] | number}}</strong></div>
        <div class="attendance-item"><span>کل مرخصی (روز)</span><strong>{{DataList_Salary['totalCalcOffDay'] | number}}</strong></div>
        <div class="attendance-item"><span>مرخصی استفاده شده (روز)</span><strong>{{DataList_Salary['usedCalcOffDay'] | number}}</strong></div>
        <div class="attendance-item"><span>مرخصی باقی مانده (روز)</span><strong>{{DataList_Salary['remainCalcOffDay'] | number}}</strong></div>
        <div class="attendance-item"><span>مرخصی ساعتی (ساعت)</span><strong>{{DataList_Salary['hourlyLeaveHours'] | number}}</strong></div>
        <div class="attendance-item"><span>وضعیت تأهل</span><strong>{{calcTahahol(DataList_Salary)}}</strong></div>
        <div class="attendance-item"><span>تعداد فرزند</span><strong>{{DataList_Salary['tedadFarzand'] | number}}</strong></div>
        <div class="attendance-item"><span>شیفت کاری</span><strong>{{DataList_Salary['salaryRecord_Person']['shift'] | number}}</strong></div>
      </div>
    </section>

    <div class="salary-body keep-together">
      <section class="salary-section payments">
        <h2>پرداخت‌ها</h2>
        <table>
          <thead><tr><th class="row-number">ردیف</th><th>عنوان</th><th class="amount">مبلغ (ریال)</th></tr></thead>
          <tbody>
            <tr><td>1</td><td>حقوق پایه</td><td>{{DataList_Salary['payeh'] | number}}</td></tr>
            <tr><td>2</td><td>پایه سنوات</td><td>{{DataList_Salary['sanavat'] | number}}</td></tr>
            <tr><td>3</td><td>حق مسکن</td><td>{{DataList_Salary['salaryRecord']['maskan'] | number}}</td></tr>
            <tr><td>4</td><td>حق تأهل</td><td>{{DataList_Salary['salaryRecord']['tahahol'] | number}}</td></tr>
            <tr><td>5</td><td>حق اولاد</td><td>{{DataList_Salary['tedadFarzand'] * DataList_Salary['salaryRecord']['farzand'] | number}}</td></tr>
            <tr><td>6</td><td>بن خوار و بار</td><td>{{DataList_Salary['salaryRecord']['kharbar'] | number}}</td></tr>
            <tr><td>7</td><td>حق عضویت بهفا</td><td>{{DataList_Salary['haghOzviyat'] | number}}</td></tr>
            <tr><td>8</td><td>حق شاغل</td><td>{{DataList_Salary['person'] | number}}</td></tr>
            <tr><td>9</td><td>حق شغل</td><td>{{DataList_Salary['position'] | number}}</td></tr>
            <tr><td>10</td><td>حق عملکرد</td><td>{{DataList_Salary['performance'] | number}}</td></tr>
            <tr><td>11</td><td>اضافه کاری</td><td>{{DataList_Salary['ezakekar'] | number}}</td></tr>
            <tr><td>12</td><td>حق مأموریت</td><td>{{DataList_Salary['mission'] | number}}</td></tr>
            <tr><td>13</td><td>هزینه ایاب و ذهاب</td><td>{{DataList_Salary['ayabZohab'] | number}}</td></tr>
            <tr><td>14</td><td>فوق‌العاده پذیرایی</td><td>{{DataList_Salary['paziraee'] | number}}</td></tr>
          </tbody>
          <tfoot><tr><th colspan="2">جمع پرداخت‌ها</th><td>{{DataList_Salary['salary2'] | number}}</td></tr></tfoot>
        </table>
      </section>

      <section class="salary-section deductions">
        <h2>کسورات</h2>
        <table>
          <thead><tr><th class="row-number">ردیف</th><th>عنوان</th><th class="amount">مبلغ (ریال)</th></tr></thead>
          <tbody>
            <tr><td>1</td><td>بیمه سهم کارمند</td><td>{{DataList_Salary['bimehKargar'] | number}}</td></tr>
            <tr><td>2</td><td>مالیات</td><td>{{DataList_Salary['maliatPay'] | number}}</td></tr>
            <tr><td>3</td><td>قسط وام / مساعده</td><td>{{getDeductionAmount(DataList_Salary, ['vam', 'loan', 'ghestVam', 'mosaedeh']) | number}}</td></tr>
            <tr><td>4</td><td>بیمه تکمیلی</td><td>{{getDeductionAmount(DataList_Salary, ['bimehTakmili', 'bimeTakmili', 'supplementaryInsurance']) | number}}</td></tr>
          </tbody>
          <tfoot><tr><th colspan="2">جمع کسورات</th><td>{{calcKosorat(DataList_Salary) | number}}</td></tr></tfoot>
        </table>
      </section>
    </div>

    <section class="salary-summary keep-together">
      <span>خالص پرداختی</span><strong>{{DataList_Salary['salary2'] - calcKosorat(DataList_Salary) | number}}</strong><small>ریال</small>
    </section>

    <section class="salary-signatures keep-together">
      <div><strong>امضاء دریافت‌کننده</strong><span>امضاء: ............................</span><span>تاریخ: ............................</span></div>
      <div><strong>امضاء واحد مربوطه</strong><span>امضاء: ............................</span><span>تاریخ: ............................</span></div>
      <div><strong>امضاء حسابداری</strong><span>امضاء: ............................</span><span>تاریخ: ............................</span></div>
    </section>

    <footer class="salary-footer keep-together"><strong>توضیحات:</strong><span>مبالغ مندرج در این فیش به ریال می‌باشد. این فیش حقوقی به صورت سیستمی صادر شده است.</span></footer>
  </div>
</div>
